import styles from './index.scss';
import React from 'react';
import { Trans } from 'react-i18next';
import { useLevvelTranslation } from '@/hooks/useLevvelTranslation';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const SentSuccess = ({ onResend }: any) => {
  const { lt } = useLevvelTranslation();
  return (
    <main className={styles.info}>
      <div className={styles.infoIcon}>
        <GreenCheck />
      </div>
      <section className={cx(['title-bold', 'infoTitle'])}>
        <span>{lt('cdb_forgot_password_send_success')}</span>
      </section>
      <p className={styles.infoDesc}>
        {lt('cdb_forgot_password_send_success_desc')}
      </p>
      <p className={styles.infoResend}>
        <Trans
          i18nKey="cdb_forgot_password_dont_receive_email"
          components={{
            i: <a onClick={onResend} className={styles.link} />,
          }}
        />
      </p>
    </main>
  );
};

export default SentSuccess;

const GreenCheck = () => (
  <svg viewBox="0 0 274 274" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2230_17451)">
      <path
        d="M137 0C61.2764 0 0 61.2764 0 137C0 212.724 61.2764 274 137 274C212.724 274 274 212.724 274 137C274 61.2764 212.724 0 137 0ZM206.745 113.835L132.018 188.562C130.524 190.056 128.531 191.053 126.289 191.053C123.549 191.551 120.809 190.804 118.816 188.811L71.7382 141.484C70.9685 140.715 70.3578 139.803 69.9411 138.799C69.5245 137.794 69.31 136.717 69.31 135.63C69.31 134.543 69.5245 133.466 69.9411 132.461C70.3578 131.457 70.9685 130.545 71.7382 129.776L75.7236 125.791C78.9618 122.553 84.1927 122.553 87.4309 125.791L125.293 163.653L190.804 98.1418C194.042 94.9036 199.273 94.9036 202.511 98.1418L206.745 102.127C209.984 105.365 209.984 110.596 206.745 113.835Z"
        fill="#40BA70"
      />
    </g>
    <defs>
      <clipPath id="clip0_2230_17451">
        <rect width="274" height="274" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
